"use client";

import { I18nUtil } from "@utils/i18n";
import React from "react";
import Translations from "@translate/components/TokenDetails/TokenDetailsSkeleton/RightSkeleton";

const I18n = I18nUtil.createScoped(Translations);

export const RightSkeleton: React.FC = () => {
  return (
    <div className="flex flex-col gap-6 w-[360px] border-l border-border_white_transparent10 pl-8">
      {/* Social Sentiment Section */}
      <div className="flex flex-col gap-4">
        <h2
          aria-label="Right Skeleton h2"
          data-openreplay-label="Right Skeleton h2 Semantic"
          id="sem-right-skeleton-h2"
          className="text-headline-s text-content_primary"
        >
          {I18n.t("Social Hype")}
        </h2>
        <div className="flex flex-col gap-3">
          <div className="flex justify-between">
            <div className="h-[22px] w-[76px] rounded bg-background_white_overlay5 animate-pulse"></div>
            <div className="h-[22px] w-[76px] rounded bg-background_white_overlay5 animate-pulse"></div>
          </div>
          <div className="w-full h-[30px] bg-background_white_overlay5 rounded animate-pulse" />
        </div>
      </div>
      <div className="w-full h-px bg-background_white_overlay5" />
      {/* Key Stats Section */}
      <div className="flex flex-col gap-4">
        <h2
          aria-label="Right Skeleton h2"
          data-openreplay-label="Right Skeleton h2 Semantic"
          id="sem-right-skeleton-h2-2"
          className="text-headline-s text-content_primary"
        >
          {I18n.t("Key Stats")}
        </h2>
        <div className="grid grid-cols-2 gap-4">
          {[...Array(8)].map((_, i) => (
            <div key={i} className="flex flex-col gap-2">
              <div className="w-[112px] h-4 bg-background_white_overlay5 rounded animate-pulse" />
              <div className="w-9 h-[18px] bg-background_white_overlay5 rounded animate-pulse" />
            </div>
          ))}
        </div>
      </div>
      <div className="w-full h-px bg-background_white_overlay5" />
      {/* What is BTC Section */}
      <div className="flex flex-col gap-4">
        <h2
          aria-label="Right Skeleton h2"
          data-openreplay-label="Right Skeleton h2 Semantic"
          id="sem-right-skeleton-h2-3"
          className="text-headline-s text-content_primary"
        >
          {I18n.t("What is BTC?")}
        </h2>
        <div className="flex flex-col gap-2">
          <div className="w-full h-4 bg-background_white_overlay5 rounded animate-pulse" />
          <div className="w-full h-4 bg-background_white_overlay5 rounded animate-pulse" />
          <div className="w-3/4 h-4 bg-background_white_overlay5 rounded animate-pulse" />
        </div>
      </div>
      <div className="w-full h-px bg-background_white_overlay5" />
      {/* Core Team Section */}
      <div className="flex flex-col gap-4">
        <h2
          aria-label="Right Skeleton h2"
          data-openreplay-label="Right Skeleton h2 Semantic"
          id="sem-right-skeleton-h2-4"
          className="text-headline-s text-content_primary"
        >
          {I18n.t("Core Team")}
        </h2>
        <div className="flex flex-wrap gap-2">
          {[...Array(5)].map((_, i) => (
            <div
              key={i}
              className="flex px-2 py-[6px] items-center gap-2 rounded-xl bg-background_white_overlay5"
            >
              <div className="w-6 h-6 rounded-full bg-background_white_overlay5 animate-pulse" />
              <div className="flex flex-col gap-2">
                <div className="w-20 h-3 bg-background_white_overlay5 rounded animate-pulse" />
                <div className="w-15 h-3 bg-background_white_overlay5 rounded animate-pulse" />
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="w-full h-px bg-background_white_overlay5" />
      {/* Investors Section */}
      <div className="flex flex-col gap-4">
        <h2
          aria-label="Right Skeleton h2"
          data-openreplay-label="Right Skeleton h2 Semantic"
          id="sem-right-skeleton-h2-5"
          className="text-headline-s text-content_primary"
        >
          {I18n.t("Investors")}
        </h2>
        <div className="flex flex-col gap-2 w-[196px]">
          {[...Array(3)].map((_, i) => (
            <div
              key={i}
              className="flex items-center gap-2 bg-background_white_overlay5 rounded py-2 pl-2 pr-3"
            >
              <div className="w-6 h-6 rounded-full bg-background_white_overlay5 animate-pulse" />
              <div className="w-[144px] h-[18px] bg-background_white_overlay5 rounded animate-pulse" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
